import axios from 'axios'
export const getTeacher = params => axios.get(`/biz/teacher/list`, { params: {...params } }) // 获取教师列表